module.exports = __webpack_public_path__ + "static/media/logo.045225fc.svg";